import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import cps from '../../img/cps.jpg'
import cpsscr from '../../img/cps.png'
import cpsFont from '../../img/cpsFont.jpg'

function Cps() {
  const { t } = useTranslation();
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className='container'>
      <MainTitle title={t('cpsTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designDecisions')}</h2>
        <p><Trans i18nKey="cpsDDTxt"></Trans></p>
        <figure>
          <img className='image-fluid' src={cpsFont} alt="Typescale" />
          <figcaption>CPS font</figcaption>
        </figure>
        <ul className='colors'>
          <li><span className='color' style={{background: "#990000"}}></span> #990000</li>
          <li><span className='color' style={{background: "#333333"}}></span> #333333</li>
          <li><span className='color' style={{background: "#8d8d8a"}}></span> #8d8d8a</li>
          <li><span className='color' style={{background: "#cccccc"}}></span> #cccccc</li>
          <li><span className='color' style={{background: "#dddddd"}}></span> #dddddd</li>
          <li><span className='color' style={{background: "#F5F5F5"}}></span> #F5F5F5</li>
        </ul>

        <h2>{t('designSystem')}</h2>
        <p><Trans i18nKey="cpsDSTxt"></Trans></p>

        <h2>{t('uxApproach')}</h2>
        <p><Trans i18nKey="cpsUXTxt" components={{ul: <ul />, li: <li />}}>
        The primary UX goal was to simplify property browsing and create an intuitive experience for users searching for homes, villas, or investment opportunities. The website structure was designed to guide users naturally through listings, filters, and property information while maintaining a clean and premium presentation.
        <br /><br />Special attention was given to:
        <ul>
          <li>clear property organization</li>
          <li>intuitive navigation flow</li>
          <li>simplified listing exploration</li>
          <li>strong visual hierarchy</li>
          <li>easy access to contact and inquiry actions</li>
        </ul>
        The experience was designed to feel professional, accessible, and visually engaging while supporting the trust and credibility expected from a modern real estate brand.
        </Trans></p>

        <h2>{t('visualDirection')}</h2>
        <p><Trans i18nKey="cpsVDTxt"></Trans></p>

        <h2>{t('figmaScr')}</h2>
        <figure>
          <img className='image-fluid' src={cpsscr} alt={t('figmaScr')} />
          <figcaption>{t('cpsScrCaption')}</figcaption>
        </figure>

        <h2>{t('finalOutcome')}</h2>
        <p><Trans i18nKey="cpsFOTxt"></Trans></p>

        <Link className="btn btn-link btn-inner mt-20" to={"https://www.croatiapropertysales.com/hr/"} target="_blank">{t('seeWebpage')}</Link>
      </div>
    </div>
  )
}

export default Cps

function ContentOne() {
  return(
    <img className="image-fluid" src={cps} alt="CPS" />
  );
}

function ContentTwo() {
  const { t } = useTranslation();

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('cpsMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={"https://www.croatiapropertysales.com/hr/"} target="_blank">{t('seeWebpage')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
      <p className='problem'><Trans i18nKey="cpsMainText2">
        The main problem to solve was: <br/><i>How to make the biggest life decision easier for the user and make it easier for them to find the desired property.</i>
      </Trans></p>
    </div>
  );
}